import { render } from "./ChaptersView.vue?vue&type=template&id=370f3fd0&scoped=true"
import script from "./ChaptersView.vue?vue&type=script&lang=js"
export * from "./ChaptersView.vue?vue&type=script&lang=js"

import "./ChaptersView.vue?vue&type=style&index=0&id=370f3fd0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f3fd0"]])

export default __exports__